import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useEditBarStore = defineStore('editBar', () => {
  const visible = ref(false);
  const onSave = ref(() => {});
  const onCancel = ref(() => {});
  const loading = ref(false);
  const updatedAt = ref('');

  const show = (saveFn = () => {}, cancelFn = () => {}) => {
    onSave.value = saveFn;
    onCancel.value = cancelFn;
    visible.value = true;
  };

  const hide = () => {
    visible.value = false;
    loading.value = false;
  };

  const triggerSave = async () => {
    loading.value = true;
    await onSave.value();
  };

  const triggerCancel = () => {
    onCancel.value();
    hide();
  };

  return {
    visible,
    loading,
    show,
    hide,
    triggerSave,
    triggerCancel,
    updatedAt,
  };
});
